import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CASES, TECH_CAPABILITIES } from "../data/services";
import { Reveal, SectionHeading } from "../components/site/Reveal";

export const Cases = () => (
  <section className="relative py-28 md:py-36" data-testid="cases-section">
    <div className="mx-auto max-w-7xl px-6">
      <SectionHeading
        eyebrow="Casos"
        title={<>Cómo se ve la <span className="text-gradient">transformación.</span></>}
        copy="Escenarios conceptuales que ilustran nuestro enfoque. Los proyectos reales se presentan en conversaciones directas."
        testId="cases-heading"
      />
      <div className="mt-16 grid gap-5 md:grid-cols-3">
        {CASES.map((c, i) => (
          <Reveal key={c.title} delay={i * 0.12}>
            <article className="group flex h-full flex-col rounded-2xl border border-[var(--line)] bg-[var(--surface)]/60 p-7 transition-colors hover:border-[var(--green)]/40" data-testid={`case-card-${i}`} data-cursor="card">
              <span className="mono w-max rounded-full border border-[var(--cyan)]/30 px-3 py-1 text-[10px] tracking-[0.25em] uppercase text-[var(--cyan)]">
                Caso conceptual
              </span>
              <h3 className="mt-6 text-xl font-bold tracking-tight">{c.title}</h3>
              <p className="mt-5 text-sm leading-relaxed text-[var(--muted)]">
                <span className="mono block text-[10px] tracking-[0.25em] uppercase text-[var(--muted)]/70 mb-1.5">Problema</span>
                {c.problem}
              </p>
              <p className="mt-4 text-sm leading-relaxed text-[var(--ink)]/85">
                <span className="mono block text-[10px] tracking-[0.25em] uppercase text-[var(--green)] mb-1.5">Solución conceptual</span>
                {c.solution}
              </p>
            </article>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.25}>
        <Link to="/proyectos" className="mt-10 inline-flex items-center gap-2 text-sm font-semibold text-[var(--green)] hover:gap-3 transition-all" data-testid="cases-link">
          Ver proyectos <ArrowUpRight size={15} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export const TechCapabilities = () => (
  <section className="relative py-20 border-y border-[var(--line)] bg-[var(--bg2)]" data-testid="tech-section">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="mono text-xs tracking-[0.35em] uppercase text-[var(--muted)] mb-8 text-center">Capacidades tecnológicas</p>
      </Reveal>
      <div className="flex flex-wrap justify-center gap-3">
        {TECH_CAPABILITIES.map((t, i) => (
          <Reveal key={t} delay={i * 0.06}>
            <span className="mono rounded-full border border-[var(--line)] bg-[var(--surface)] px-6 py-2.5 text-sm tracking-wider text-[var(--ink)]/80 transition-colors hover:border-[var(--cyan)]/50 hover:text-[var(--cyan)]">
              {t}
            </span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
